import { DomHelper } from "./domHelper";
import { getBackendData } from "./xhrbackend";
import { getAppCardNode } from "./appCardDefault";
import { Util } from "./util";
import { DEBUG } from "./config";
function handleClickOpen(injectNode, username, bearerToken, userPreferences) {
    const appNode = DomHelper.getFirstParentWithClass(injectNode, 'rudi-app');
    setTimeout(() => DomHelper.scrollIntoView(injectNode), 500);
    injectNode.classList.remove('rudi-app-inject');
    injectNode.classList.remove('disabled');
    injectNode.classList.add('rudi-app-interaction');
    injectNode.setAttribute("id", 'rudi-sap-asp');
    if (appNode) {
        if (appNode.classList.contains("app-open")) {
            if (DEBUG)
                console.log("RespApp do nothing");
        }
        else {
            appNode.classList.add('app-open');
            const availableResponsibilities = [
                { id: 'HWB', name: 'Zuständig für Hardware vor Ort' },
                { id: 'VBV', name: 'Zuständig für Ihre Berechtigungsvergabe' },
                { id: 'VGA', name: 'Zuständig für Ihre Gehaltsabrechnung' },
                { id: 'VPF', name: 'Zuständig für Ihre Personalfragen' },
                { id: 'MAV', name: 'Mitarbeitendenvertretung' },
                { id: 'BSH', name: 'Brandschutzhelfer/in' },
                { id: 'EHH', name: 'Erste Hilfe Helfer/in' },
                { id: 'EDV', name: 'Hilfe bei IT-Problemen' }
            ];
            const listNode = prepareListNode(appNode, injectNode, availableResponsibilities);
            getBackendData(`${username}/responsibilites?variations=HWB|VBV|VGA|VPF`, "/users/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                replaceSkeletonWithData(listNode, username, userPreferences, responseData.data, bearerToken);
            });
            getBackendData(`${username}/responsibilites?variations=EDV`, "/users/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                replaceSkeletonWithData(listNode, username, userPreferences, responseData.data, bearerToken);
            });
            getBackendData(`${username}/responsibilites?variations=EHH`, "/users/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                replaceSkeletonWithData(listNode, username, userPreferences, responseData.data, bearerToken);
            });
            getBackendData(`${username}/responsibilites?variations=BSH`, "/users/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                replaceSkeletonWithData(listNode, username, userPreferences, responseData.data, bearerToken);
            });
            getBackendData(`${username}/responsibilites?variations=MAV`, "/users/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                replaceSkeletonWithData(listNode, username, userPreferences, responseData.data, bearerToken);
            });
        }
    }
}
export function appRelatedResponsiblitiesRender(username, bearerToken, userPreferences, parentNode, app) {
    if (DEBUG)
        console.log("-->appRelatedResponsiblities");
    const additionalClassList = [];
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, false, additionalClassList, null, (event) => {
        let injectNode = cardNode.querySelector('.rudi-app-inject');
        handleClickOpen(injectNode, username, bearerToken, userPreferences);
    });
}
function appendSkeleton(injectNode, category) {
    const sectionNode = DomHelper.appendNode(injectNode, 'section', ['skeleton'], [], '', category.id);
    const h4 = DomHelper.appendNode(sectionNode, 'h4', ['skeleton'], [], category.name);
    DomHelper.appendNode(sectionNode, 'p', ['skeleton'], [], '... Daten werden geladen ...');
}
function prepareListNode(cardNode, injectNode, idList) {
    cardNode.classList.add('rudi-row-span-2');
    cardNode.classList.add('rudi-col-span-2');
    cardNode.classList.remove('rudi-max-height');
    for (let id of idList) {
        appendSkeleton(injectNode, id);
    }
    DomHelper.appendCloseSection(cardNode, (event) => {
        const parentNode = document.getElementById("rudi-sap-asp");
        if (parentNode) {
            parentNode.classList.add('rudi-app-inject');
            parentNode.classList.remove('rudi-app-interaction');
            parentNode.innerHTML = "";
        }
        cardNode.classList.remove('rudi-row-span-2');
        cardNode.classList.remove('rudi-col-span-2');
        cardNode.classList.remove('app-open');
        cardNode.classList.add('rudi-max-height');
        parentNode.innerHTML = "";
        DomHelper.scrollIntoView(cardNode);
    });
    return injectNode;
}
function replaceSkeletonWithData(parentNode, username, userPreferences, relatedRes, bearerToken) {
    if (DEBUG)
        console.log("-->appRelatedResponsibilitesPartRender");
    for (const resp of relatedRes) {
        const skeleton = parentNode.querySelector(`#${resp.id}`);
        if (skeleton) {
            skeleton.classList.remove('skeleton');
            const skeletonHeadline = skeleton.querySelector('h4');
            const pSkeleton = skeleton.querySelector('p');
            if (skeletonHeadline && pSkeleton) {
                skeletonHeadline.classList.remove('skeleton');
                pSkeleton.remove();
                skeletonHeadline.innerHTML = resp.name;
                for (const person of resp.people) {
                    const p = DomHelper.appendNode(skeleton, 'p', []);
                    DomHelper.appendNode(p, 'i', ['fa-light', 'fa-address-card', 'me-1', 'fixed-color']);
                    const pHead = DomHelper.appendNode(p, 'span', ['rudi-sap-asp-name', 'themed-color'], [{ attr: 'href', value: `mailto:${person.Email}` }], `${person.Vorname} ${person.Nachname}`);
                    const tableId = Util.generateRandomDomId();
                    const table = DomHelper.appendNode(p, "aside", ['disabled', 'rudi-table'], [{ attr: 'id', value: tableId }]);
                    if (table) {
                        if (person.Telefon1 && person.Telefon1 != "")
                            DomHelper.addTableRow(table, ['Telefon', person.Telefon1], [], [], 1, 'tel:');
                        if (person.Mobil && person.Mobil != "")
                            DomHelper.addTableRow(table, ['Mobil', person.Mobil], [], [], 1, 'tel:');
                        if (person.Email && person.Email != "")
                            DomHelper.addTableRow(table, ['Email', person.Email], [], [], 1, 'mailto:');
                    }
                    pHead.addEventListener('click', function (event) {
                        const tableNode = document.getElementById(tableId);
                        if (tableNode)
                            tableNode.classList.toggle('disabled');
                    });
                }
            }
        }
    }
}
